/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { MessageResponseApiModel } from '../api-models/message-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { ClientApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root'
})
export class PkpassApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: ClientApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Generate and return .pkpass for loyalty customers card
   * @endpoint get /pkpass/loyalty/{loyalty_id}/customers/card/{card_id}/generate
   * @param loyaltyId Loyalty ID
   * @param cardId Customers card ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPkpassLoyaltyCustomersCardGenerate(
    loyaltyId: string,
    cardId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/vnd.apple.pkpass';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public incustControllersClientClientPkpassLoyaltyCustomersCardGenerate(
    loyaltyId: string,
    cardId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/vnd.apple.pkpass';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public incustControllersClientClientPkpassLoyaltyCustomersCardGenerate(
    loyaltyId: string,
    cardId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/vnd.apple.pkpass';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public incustControllersClientClientPkpassLoyaltyCustomersCardGenerate(
    loyaltyId: string,
    cardId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/vnd.apple.pkpass';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (loyaltyId === null || loyaltyId === undefined) {
      throw new Error(
        'Required parameter loyaltyId was null or undefined when calling incustControllersClientClientPkpassLoyaltyCustomersCardGenerate.'
      );
    }
    if (cardId === null || cardId === undefined) {
      throw new Error(
        'Required parameter cardId was null or undefined when calling incustControllersClientClientPkpassLoyaltyCustomersCardGenerate.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/vnd.apple.pkpass']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pkpass/loyalty/${this.configuration.encodeParam({
      name: 'loyaltyId',
      value: loyaltyId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/customers/card/${this.configuration.encodeParam({
      name: 'cardId',
      value: cardId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/generate`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress
    });
  }
}
